/* storybook-check-ignore */
import { Flex } from '@opendoor/bricks/core';

interface IconProps {
  size?: number;
  color?: string;
}

const SparkleIcon = ({ size = 33, color = 'var(--colors-brand50)' }: IconProps) => {
  return (
    <Flex
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      justifyContent="center"
      alignItems="center"
    >
      <svg
        fill="none"
        width="100%"
        height="100%"
        viewBox={`0 0 33 33`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={color}
          d="M31.9086 15.1137C33.3636 15.4632 33.3639 17.5329 31.9089 17.8827C24.97 19.5508 19.5528 24.9693 17.8863 31.9086C17.5368 33.3636 15.4671 33.3639 15.1173 31.9089C13.4492 24.97 8.03068 19.5528 1.09139 17.8863C-0.363622 17.5368 -0.363862 15.4671 1.09107 15.1173C8.02997 13.4492 13.4472 8.03068 15.1137 1.09139C15.4632 -0.363622 17.5329 -0.363862 17.8827 1.09107C19.5508 8.02997 24.9693 13.4472 31.9086 15.1137Z"
        />
      </svg>
    </Flex>
  );
};

export default SparkleIcon;
